export default "__VITE_ASSET__650a6967__"